import React from 'react';
import { motion } from 'framer-motion';
import { PhoneFrame } from './PhoneFrame';
import { screens } from '../data/screens';
export function MyBalance() {
  return <section className="bg-[#FFFBF2] py-20 lg:py-28" data-id="element-197" data-mp="1mdz8f0eodk82">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-198" data-mp="215hw7kds0j1z">
        <div className="grid items-center gap-14 lg:grid-cols-12 lg:gap-16" data-id="element-199" data-mp="1wdzrcl8mtybq">
          <motion.div initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.55,
          ease: [0.22, 1, 0.36, 1]
        }} className="mx-auto w-full max-w-[330px] lg:col-span-5 lg:max-w-[350px]" data-id="element-200" data-mp="1wbwvhkkstaz3">
            <PhoneFrame screen={screens.myBalance} shadow="xl" data-id="element-201" data-mp="2f3y2ja7q87jl" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-7" data-id="element-202" data-mp="pp9ol4jhmhjg">
            <h2 className="mb-5 text-3xl font-black leading-[1.05] tracking-tight text-kitty-dark md:text-4xl lg:text-5xl" data-id="element-203" data-mp="2jhjdncc83q3s">
              Everything you're owed.
              <br data-id="element-204" data-mp="2sg4wz9pir95m" />
              One place.
            </h2>
            <p className="mb-8 max-w-lg text-lg leading-relaxed text-gray-600 lg:text-xl" data-id="element-205" data-mp="2x73c45yru17a">
              See what you owe and what you're owed across all of your kitties.
            </p>

            <div className="grid gap-4 sm:grid-cols-2" data-id="element-206" data-mp="328iyc1coqdr9">
              <div className="rounded-3xl border border-gray-100 bg-white p-7 shadow-soft" data-id="element-207" data-mp="3747ya5sm9wo3">
                <p className="mb-1.5 text-sm font-bold uppercase tracking-wide text-gray-500" data-id="element-208" data-mp="3b7xmuv9ake94">
                  Every kitty at once
                </p>
                <p className="text-base leading-relaxed text-gray-700" data-id="element-209" data-mp="3g3lc1anrx7em">
                  Ski trip, weekend away, the house. One total, then the
                  detail per kitty and per person.
                </p>
              </div>
              <div className="rounded-3xl border border-gray-100 bg-white p-7 shadow-soft" data-id="element-210" data-mp="2p22atra76yx2">
                <p className="mb-1.5 text-sm font-bold uppercase tracking-wide text-gray-500" data-id="element-211" data-mp="2k4agyrpzt2q8">
                  Travelling abroad?
                </p>
                <p className="text-base leading-relaxed text-gray-700" data-id="element-212" data-mp="2y4tm9r32puop">
                  Each kitty runs in its own currency. My Balance can show an
                  estimate in the currency you prefer, so the total makes sense
                  at a glance.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}